import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { BookingProfileStatus } from '../../constants';
import { getNameInitialsFromFullName } from '../../core/util/string';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';

const Container = styled.div.withConfig({ componentId: 'sc-1y777cl-0' })`
  border: 1px solid ${colors.grayvy};
  font-family: ${fontFamily.book};
  cursor: pointer;
  padding: 10px 7px 7px 20px;
  border-radius: 4px;
`;

const StyledProfileContainer = styled.div.withConfig({ componentId: 'sc-1y777cl-1' })`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const NameContainer = styled.div.withConfig({ componentId: 'sc-1y777cl-2' })`
  background-color: ${colors.blueJayWay};
  ${(props) => css`
    background-color: ${
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      props.color.primary
    };
  `};
  border-radius: 50%;
  color: white;
  height: 30px;
  margin-right: 15px;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  width: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: ${fontSize.default};
`;

const StyledPlusSign = styled.img.withConfig({ componentId: 'sc-1y777cl-3' })`
  height: 20px;
  margin: 0px 15px 0px 2px;
  width: 20px;
  display: inline-block;
`;

type Props = {
  className?: string;
  placeholder?: string;
  value?: any;
  customArrow?: boolean;
};

const SelectValue = (props: Props) => {
  const { t } = useTranslation();
  const { className } = props;
  const { type, label, color } = props.value;
  const fullName = label;

  return (
    <Container className={className} title={fullName}>
      <StyledProfileContainer>
        {type === BookingProfileStatus.EXISTS ? (
          <>
            <NameContainer color={color}>{getNameInitialsFromFullName(fullName, '')}</NameContainer>
            {fullName}
          </>
        ) : (
          <>
            <StyledPlusSign alt="plus-sign" src="/images/icons/plus-circle.svg" />
            {t('addNewFamilyMember')}
          </>
        )}
      </StyledProfileContainer>
    </Container>
  );
};

export default SelectValue;
